import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  formInfoLabel: {
    fontSize: '16px',
  },

  subFormInfoLabel: {
    fontSize: '12px',
    marginTop: theme.spacing(0.3),
  },
})
